<template>
    <kiosk-team-details :teamId="props.teamId" data-test="kiosk-team-details">
        <div
            class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center"
            data-test="plan-information-wrapper"
        >
            <plan-information
                v-model="team"
                :teamPlan="props.teamPlan"
                :teamMessageBalance="props.teamMessageBalance"
                :teamSumBalanceAmount="props.teamSumBalanceAmount"
                :kioskMode="true"
                :isAdminOrOwner="true"
                data-test="plan-information"
            >
            </plan-information>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import PlanInformation from '~/components/settings/teams/plan-information/PlanInformation.vue';

const { team } = useTeamDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    teamPlan: {
        type: Object,
        required: true,
    },
    teamMessageBalance: {
        type: Number,
        required: true,
    },
    teamSumBalanceAmount: {
        type: Number,
        required: true,
    },
});
</script>
